const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5014/api/v1';

// Identity comes from the JWT; the backend derives the user's DAMS folder from knktId.
const authHeaders = () => {
  const token = localStorage.getItem('knkt_ue_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const toError = async (response, fallback) => {
  const body = await response.json().catch(() => ({}));
  return new Error(body.message || body.error || fallback);
};

export const imagesAPI = {
  /**
   * Upload image (stored in DAMS; response.image.url is the public DAMS URL)
   */
  upload: async (file, category = 'other', tags = []) => {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('category', category);
    if (tags.length > 0) {
      formData.append('tags', tags.join(','));
    }

    const response = await fetch(`${API_BASE_URL}/images/upload`, {
      method: 'POST',
      headers: authHeaders(),
      body: formData,
    });
    if (!response.ok) throw await toError(response, 'Failed to upload image');
    return response.json();
  },

  /**
   * Get the signed-in user's images
   */
  getAll: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = `${API_BASE_URL}/images${queryString ? `?${queryString}` : ''}`;
    const response = await fetch(url, { headers: authHeaders() });
    if (!response.ok) throw await toError(response, 'Failed to fetch images');
    return response.json();
  },

  /**
   * Delete image (id = DAMS asset name)
   */
  delete: async (id) => {
    const response = await fetch(`${API_BASE_URL}/images/${encodeURIComponent(id)}`, {
      method: 'DELETE',
      headers: authHeaders(),
    });
    if (!response.ok) throw await toError(response, 'Failed to delete image');
    return response.json();
  },
};

export default imagesAPI;
